export interface ISystemDocumentType {
  [key: string]: { key: string; name: string };
}

export const SystemDocumentType: ISystemDocumentType = {
  RAMS: { key: "RAMS", name: "RAMS" },
  SMD: { key: "Drawing", name: "SMD" },
  ARC_GIS_DRAWING: { key: "ArcGisDrawing", name: "ArcGis" },
};
